import { Module } from 'vuex';
import { LOCAL_STORAGE_KEYS, setLocalStorageValue, getLocalStorageValue } from '@/constants/localStorage';

export interface GraphState {
  selectedTimeFrame: string;
  selectedCandleCount: number;
}

const state: GraphState = {
  selectedTimeFrame: getLocalStorageValue(LOCAL_STORAGE_KEYS.SELECTED_TIMEFRAME) || '1m',
  selectedCandleCount: parseInt(getLocalStorageValue(LOCAL_STORAGE_KEYS.SELECTED_CANDLE_COUNT) || '50'),
};

const mutations = {
  selectTimeFrame(state: GraphState, payload: string) {
    state.selectedTimeFrame = payload;
    setLocalStorageValue(LOCAL_STORAGE_KEYS.SELECTED_TIMEFRAME, payload);
  },
  selectCandleCount(state: GraphState, payload: number) {
    state.selectedCandleCount = payload;
    setLocalStorageValue(LOCAL_STORAGE_KEYS.SELECTED_CANDLE_COUNT, payload.toString());
  },
};

const actions = {
  selectTimeFrame({ commit }: any, payload: string) {
    commit('selectTimeFrame', payload);
  },
  selectCandleCount({ commit }: any, payload: number) {
    commit('selectCandleCount', payload);
  },
};

const getters = {
  selectedTimeframe: (state: GraphState) => state.selectedTimeFrame,
  selectedCandleCount: (state: GraphState) => state.selectedCandleCount,
};

const graph: Module<GraphState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default graph;
